import * as yup from 'yup';
import { nullableStringYup } from '@/utils';

export const efsValidationSchema = yup.object().shape({
  displayName: nullableStringYup().required('Display Name is required'),
  userName: nullableStringYup().required('Username is required'),
  password: nullableStringYup().required('Password is required'),
});
